import React, {PropTypes} from 'react';
import {inject, observer} from "mobx-react/index";
import Form, {DateInput, FormActions, FormBody, SelectInput} from "../../Form";
import {action, autorunAsync, observable} from "mobx/lib/mobx";
import moment from "moment/moment";
import Spinner from "../../Spinner";

@inject('stationStore', 'dataSeriesStore', 'qcTypeStore', 'qcCheckStore', 'qcRuleStore', 'parameterStore')
@observer
export default class StationManualQc extends React.Component {

  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };


  @observable station = {};
  @observable dataSeriesItems = [];
  @observable qcTypeItems = [];

  dispose;

  componentWillMount() {
    const {params: {id}, stationStore, dataSeriesStore, parameterStore, qcRuleStore} = this.props;
    if(!parameterStore.items.length && !parameterStore.isLoading) parameterStore.fetchItems();
    this.dispose = autorunAsync(() => {
      dataSeriesStore.fetchItems();
      stationStore.fetchDataSeries(id).then(items => {
        this.resetDataSeriesItems(items)
      });
      qcRuleStore.fetchItems().then(items => {
        this.resetQcTypeItems(items)
      })
    });
  }

  componentWillUnmount() {
    const {qcCheckStore} = this.props;
    this.dispose();
    if(!qcCheckStore.loading) qcCheckStore.resetFilters();
  }

  @action resetDataSeriesItems(item) {
    if (!item) {
      return;
    }
    // this.station = item.asJson;
    const {parameterStore} = this.props;
    this.dataSeriesItems = item.map(item => (Object.assign(item, {parameter: parameterStore.findById(item.parameter_id)})));
  }

  @action resetQcTypeItems(item) {
    if (!item) {
      return;
    }
    // this.station = item.asJson;
    this.qcTypeItems = item;
  }

  startManualQC = e => {
    e.preventDefault();
    const {qcCheckStore} = this.props;
    const {notify} = this.context;
    qcCheckStore.loading = true;
    qcCheckStore.startManualQC(qcCheckStore.filters).then(res => {
      qcCheckStore.loading = false;
      notify.success(res);
    }).catch(err => {
      console.error(err);
      notify.error(err);
      qcCheckStore.loading = false;
    })
  };

  render() {
    const {qcCheckStore, parameterStore} = this.props;
    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput label='DataSeries'
                         value={qcCheckStore.filters.series_id}
                         fields={{label: 'name', value: 'id'}}
                         options={this.dataSeriesItems}
                         onChange={qcCheckStore.onChangeSeries}
                         filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}/>
            <DateInput label='Date From' type='datetime-local'
                       value={qcCheckStore.filters.date_from}
                       onChange={qcCheckStore.onChangeDateFrom}/>
            <DateInput label='Date To' type='datetime-local'
                       value={qcCheckStore.filters.date_to}
                       onChange={qcCheckStore.onChangeDateTo}/>
            <SelectInput label='QC Rule'
                         value={qcCheckStore.filters.qc_type}
                         fields={{label: 'description', value: 'id'}}
                         options={this.qcTypeItems}
                         onChange={qcCheckStore.onChangeQcType}/>
          </FormBody>
          <FormActions>
            <button onClick={this.startManualQC}>Run QC</button>
          </FormActions>
        </Form>
        {qcCheckStore.loading && <Spinner/>}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Station/QcCheck/StationManualQc.js